var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentUser && _vm.mobile)?_c('v-app-bar',{staticStyle:{"position":"absolute"},attrs:{"app":"","color":_vm.mainColor,"flat":"","dense":""}},[_c('v-btn',{staticClass:"d-flex",attrs:{"icon":""},on:{"click":_vm.openNavbar}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-menu")])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }